import { useCurrentStateAndParams } from "@uirouter/react";

import { betaVsLiveSwitchToggle } from "app/actions/commonActions";
import { isAvailable, isLocked } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";
import { FiltersEnum } from "app/components/filters-bar/utils";
import { AccessWithoutMandatoryParamsHOC } from "app/components/React/HOCs/accessWithoutMandatoryParamsHOC";
import { withAllContextHoc } from "app/components/React/HOCs/withAllContextsHOC";
import { SecondarySideBarType3 } from "app/components/sidebar3/types";
import { CompetitiveAnalysisHomepage } from "app/pages/digital-marketing/CompetitiveAnalysis";
import { DigitalMarketingContainer } from "app/pages/digital-marketing/DigitalMarketingContainer";
import { DigitalMarketingRedirectPage } from "app/pages/digital-marketing/home-pages/DigitalMarketingRedirectPage";
import { basicReportsForAfterTrial, navigationTiles } from "app/pages/digital-suite/home-page/constants";
import { CompanyResearchRoot } from "app/pages/market-research/CompanyResearchRoot";
import { journeyTransitionRedirect } from "app/pages/segment-user-flow/buyer-journey/JourneyTransitionRedirect";
import { SegmentUserFlowContainer } from "app/pages/segment-user-flow/buyer-journey/SegmentUserFlowContainer";
import SegmentsAnalysisTrafficContainer from "app/pages/segments/analysis/SegmentsAnalysisTrafficContainer";
import { SEGMENTS_ANALYSIS_ABSTRACT_PARENT_ID } from "app/pages/segments/config/const";
import { ETab } from "app/pages/segments/features/segments-homepage/types";
import SegmentsGeographyContainer from "app/pages/segments/geography/SegmentsGeographyContainer";
import SegmentsAnalysisMarketingChannelsContainer from "app/pages/segments/mmx/SegmentsAnalysisMarketingChannelsContainer";
import { SegmentsAnalysisRootContainer } from "app/pages/segments/SegmentsAnalysisRootContainer";
import { SegmentsHomepageContainer } from "app/pages/segments/SegmentsHomepageContainer";
import { SegmentsRootContainer } from "app/pages/segments/SegmentsRootContainer";
import { SegmentsWizardWrapper } from "app/pages/segments/wizard/SegmentWizard/SegmentWizardWrapper";
import { SneakpeekQuery } from "app/pages/sneakpeek/SneakpeekQuery";
import { SneakpeekResultsPage } from "app/pages/sneakpeek/SneakpeekResultsPage";
import { AdvertisersContainer } from "app/pages/website-analysis/analyze-publishers/advertisers/AdvertisersContainer";
import { MonetizationNetworksContainer } from "app/pages/website-analysis/analyze-publishers/monetization-networks/MonetizationNetworksContainer";
import CompetitiveLandscapePage from "app/pages/website-analysis/competitive-landscape/CompetitiveLandscapePage";
import { QualificationSideBarContainer } from "app/pages/website-analysis/components/qualification-sidebar/QualificationSideBarContainer";
import { onEnterRemoveComparedDuration } from "app/pages/website-analysis/config/onEnterRemoveComparedDuration";
import { marketingChannelsPageViewTracking } from "app/pages/website-analysis/config/pageViewTracking";
import { WebsiteAnalysisModuleFrame } from "app/pages/website-analysis/frame/WebsiteAnalysisModuleFrame";
import { MmxBetaContainer } from "app/pages/website-analysis/traffic-sources/mmx/mmx-beta/MmxBetaContainer";
import { MmxContainer } from "app/pages/website-analysis/traffic-sources/mmx/MmxContainer";
import BetaBranchGreenBadgeComponent from "app/pages/website-analysis/TrafficAndEngagement/BetaBranch/BetaBranchGreenBadgeComponent";
import { WebsiteAnalysisTrafficContainerConnected } from "app/pages/website-analysis/TrafficAndEngagement/WebsiteAnalysisTrafficContainer";
import {
    AudienceWrapper,
    ECategoryAudienceType,
} from "app/pages/website-analysis/website-structure/pages/AudienceWrapper";
import { WebsiteContent } from "app/pages/website-analysis/website-structure/pages/WebsiteContent";
import { WebsiteContentLockedPage } from "app/pages/website-analysis/pages/WebsiteContentLockedPage";
import { WebsiteTechnologiesPage } from "app/pages/website-analysis/website-technologies/WebsiteTechnologiesPage";
import { WebsiteTechnologiesSubNav } from "app/pages/website-analysis/website-technologies/WebsiteTechnologiesSubNav";
import { DigitalSuiteWorldwideOverview } from "app/pages/website-performance/digital-suite/DigitalSuiteWorldwideOverview";
import { DigitalSuiteWorldwideOverviewCompare } from "app/pages/website-performance/digital-suite/DigitalSuiteWorldwideOverviewCompare";
import { filterConsistencyParams } from "app/routes/handlers/filter-consistency/filterConsistencyUtils";
import { onRedirectSegmentAnalysis } from "app/routes/handlers/filter-consistency/pipes/segment-analysis/onRedirectSegmentAnalysis";
import {
    onRedirectWebsiteAnalysis,
    onRedirectWebsiteAnalysisWithTotalWebSource,
} from "app/routes/handlers/filter-consistency/pipes/website-analysis/onRedirectWebsiteAnalysis";
import { onRedirectWebsitePerformance } from "app/routes/handlers/filter-consistency/pipes/website-analysis/onRedirectWebsitePerformance";
import { fallback } from "app/routes/handlers/redirectFunctions/fallback";
import { redirectPipe } from "app/routes/handlers/redirectFunctions/redirectPipe";
import { USE_BETA_BRANCH_DATA_PREF_KEY } from "app/routes/websiteStateConfigConstants";
import { AssetsService } from "app/services/AssetsService";
import { PdfExportService } from "app/services/PdfExportService";
import { PreferencesService } from "app/services/preferences/preferencesService";
import { SwRedux } from "app/services/SwRedux";
import { GrowthbookService, TestsNames } from "app/services/trackingServices/GrowthBookService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { isNoTouchOrTrialOrAfterTrial, isAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/trialUsersUtils";
import { resolvers } from "single-spa/react-app/config/resolvers/resolvers";
import { competitionAppAnalysisConfig } from "single-spa/react-app/config/solutions25/competitionAppAnalysisConfig";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

import {
    SELECTED_TRAFFIC_METRIC_QUERY_PARAM,
    SELECTED_ENGAGMENT_METRIC_QUERY_PARAM,
    TRAFFIC_ENGAGED_USERS_QUERY_PARAM,
    ENGAGEMENT_ENGAGED_USERS_QUERY_PARAM,
    TRAFFIC_MONTH_TO_DATE_QUERY_PARAM,
    ENGAGEMENT_MONTH_TO_DATE_QUERY_PARAM,
} from "./competitionConst";
import { competitionMarketingAnalysisConfig } from "./competitionMarketingConfig";
import { isNoTouch } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

const FILTER_CONSISTENCY_CUSTOM_KEYS = {
    filterConsistencyTooltipTitleKey: "segments.analysis.filter.consistency.tooltip.title",
    filterConsistencyTooltipTextKey: "segments.analysis.filter.consistency.tooltip.text",
};

export async function fetchAndUpdateBetaBranchPreference() {
    try {
        const showBetaBranchData = PreferencesService.get(USE_BETA_BRANCH_DATA_PREF_KEY);
        if (showBetaBranchData) {
            SwRedux.getInstance().dispatch(betaVsLiveSwitchToggle(showBetaBranchData, false));
        }
        return true;
    } catch (e) {
        return true;
    }
}

export const trafficAndEngagementQueryParams = `comparedDuration&webSource&key&category&${TRAFFIC_ENGAGED_USERS_QUERY_PARAM}&${ENGAGEMENT_ENGAGED_USERS_QUERY_PARAM}&${SELECTED_TRAFFIC_METRIC_QUERY_PARAM}&${SELECTED_ENGAGMENT_METRIC_QUERY_PARAM}`;
const config: RouterStateConfig = {
    digitalsuite_websiteanalysis: {
        parent: "sw",
        abstract: true,
        packageName: "digitalsuite",
        component: DigitalMarketingContainer,
        configId: "DigitalSuiteCompetitveSection",
        secondaryBarType: "DigitalSuiteCompetition",
        secondaryBarType3: SecondarySideBarType3.WebsiteAnalysis,
        isSecondaryBarOpen: true,
        navBarContainerClassName: "accordion-side-bar",
    },
    "digitalsuite_websiteanalysis-root": {
        abstract: true,
        parent: "digitalsuite_websiteanalysis",
        secondaryBarType: "DigitalSuiteCompetition",
        secondaryBarType3: SecondarySideBarType3.WebsiteAnalysis,
        component: () => <CompanyResearchRoot />,
    },
    digitalsuite_websiteanalysis_home: {
        parent: "digitalsuite_websiteanalysis",
        url: "/digitalsuite/websiteanalysis/home",
        component: () => (
            <CompetitiveAnalysisHomepage
                title={"digitalsuite_companyresearch_websiteanalysis_home"}
                isWAHomePageTrial={true}
            />
        ),
        configId: "DigitalSuiteCompetitveSection",
        configIdDeps: ["WorldwideOverviewPage", "MobileWebCustomSegmentsAnalysis"],
        secondaryBarType: "DigitalSuiteCompetition",
        isSecondaryBarOpen: true,
        clearSearch: true, // required for clean selected entities on tracking
        pageId: {
            section: "marketresearch",
            subSection: "companyresearch",
            subSubSection: "analyzewebsites",
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Website Analysis/Home",
            subSubSection: "Analyze Websites",
        },
        pageTitle: "companyintelligence.analyzewebsites.homepage.title",
    },
    digitalsuite_website: {
        parent: "digitalsuite_websiteanalysis-root",
        params: {
            key: {
                dynamic: false,
            },
        },
        url: "/digitalsuite/websiteanalysis",
        component: withAllContextHoc(WebsiteAnalysisModuleFrame),
        abstract: true,
        configId: "WebAnalysis",
        resolve: [resolvers.customCategories],
        data: {
            menuId: "websites",
            filtersConfig: {
                duration: FiltersEnum.ENABLED,
                country: FiltersEnum.ENABLED,
                webSource: FiltersEnum.ENABLED,
            },
        },
    },
    competitionRedirect: {
        parent: "digitalsuite_websiteanalysis",
        url: "/redirect/:id",
        component: () => {
            return (
                <DigitalMarketingRedirectPage
                    navigationTiles={isAfterTrial() ? basicReportsForAfterTrial : navigationTiles}
                />
            );
        },
        configId: "WebAnalysis",
        configIdDeps: ["WorldwideOverviewPage", "MobileWebSearch"],
        pageId: {
            section: "digitalmarketing",
            subSection: "redirect",
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "redirect",
            subSubSection: "",
        },
        pageTitle: "digitalmarketing.homepage.title",
    },
    digitalsuite_website_websiteperformance: {
        parent: "digitalsuite_website",
        url: "/overview/website-performance/:isWWW/:country/:duration?webSource&key",
        component: AccessWithoutMandatoryParamsHOC(function Component() {
            return useCurrentStateAndParams().params.key?.split(",").length > 1 ? (
                <DigitalSuiteWorldwideOverviewCompare />
            ) : (
                <DigitalSuiteWorldwideOverview />
            );
        }, "key"),
        params: {
            isWWW: "*",
            country: "999",
            duration: "3m",
            ...filterConsistencyParams,
        },
        configId: "WorldwideOverviewPage",
        configIdDeps: ["WebAnalysis", "MobileWeb", "MobileWebWorldwide"],
        redirectTo: redirectPipe(
            fallback({
                salesIntelligence: "accountreview_website_overview_websiteperformance",
            }),
            onRedirectWebsitePerformance(),
        ),
        data: {
            gaSupport: true,
            filtersConfig: {
                webSource: FiltersEnum.DISABLED,
            },
        },
        worldwideOnly: true,
        pageId: {
            section: "website",
            subSection: "worldwideOverview",
            subSubSection: null,
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Website Analysis/Overview",
            subSubSection: "websitePerformance",
        },
        icon: "sw-icon-overview",
        pageTitle: "analysis.overview.performance.title",
        stateNameForEductionBar: "competitiveanalysis_website_overview_websiteperformance",
        get isPdfDownloadButton() {
            const { key } = proNavigator.getParams();
            return key !== undefined;
        },
        pdfDownloadsMethod: () => PdfExportService.downloadPaidPdfFedService("wwo.report.link", "wwo.report.title"),
        resolve: [resolvers.siteInfo],
        hidePageTitle: true,
        defaultQueryParams: {
            webSource: devicesTypes.TOTAL,
            isWWW: "*",
            country: 999,
            duration: "3m",
        },
        reloadOnSearch: true,
        isUSStatesSupported: true,
        homeState: "digitalsuite_websiteanalysis_home",
        get showCreateCustomIndustryCta() {
            return !isNoTouchOrTrialOrAfterTrial();
        },
    },
    digitalsuite_website_competitivelandscape: {
        parent: "digitalsuite_website",
        url: "/overview/competitive-landscape/:isWWW/:country/:duration?key&similarsites_filters&similarsites_orderby&selectedSite",
        component: AccessWithoutMandatoryParamsHOC(CompetitiveLandscapePage, "key"),
        qualificationSideBarComponent: QualificationSideBarContainer,
        stateNameForEductionBar: "companyresearch_website_competitivelandscape",
        resolve: [resolvers.siteInfo],
        redirectTo: redirectPipe(
            fallback({
                salesIntelligence: "accountreview_website_competitivelandscape",
            }),
            onRedirectWebsiteAnalysis(),
        ),
        params: {
            isWWW: "*",
            country: "999",
            duration: "3m",
            ...filterConsistencyParams,
        },

        pageId: {
            section: "website",
            subSection: "competitors",
            subSubSection: "similarsites",
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Website Analysis/Overview",
            subSubSection: "competitiveLandscape",
        },
        icon: "sw-icon-similarsites",
        pageTitle: "digitalsuite.analysis.overview.competitors.similarsites.title",
        isVirtualSupported: false,
        isUSStatesSupported: true,
        configId: "WebsiteCompetitors",
        reloadOnSearch: true,
        hideCalendar: true,
        overrideDatepickerPreset: ["3m"],
        minDurationRange: 3,
        defaultQueryParams: {
            duration: "3m",
            isWWW: "*",
            country: "999",
        },
        data: {
            filtersConfig: {
                duration: FiltersEnum.DISABLED,
                country: FiltersEnum.DISABLED,
            },
        },
        homeState: "digitalsuite_websiteanalysis_home",
    },
    digitalsuite_websites_technologiesOverview: {
        parent: "digitalsuite_website",

        url: "/technologies-overview/:isWWW?category&key",
        params: {
            isWWW: "*",
        },
        component: AccessWithoutMandatoryParamsHOC(WebsiteTechnologiesPage, "key"),
        redirectTo: redirectPipe(
            fallback({
                salesIntelligence: "accountreview_website_technologies",
            }),
        ),
        periodOverPeriodEnabled: false,
        configId: "WebTechnographics",
        pageId: {
            section: "Digital Marketing",
            subSection: "Competitive Analysis",
            subSubSection: "technographics",
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Website Analysis/Website Structure",
            subSubSection: "technographics",
        },
        icon: "sw-icon-overview",
        pageTitle: "analysis.overview.technographics.title",
        pageSubtitle: "analysis.overview.technographics.subtitle",
        resolve: [resolvers.siteInfo],
        data: {
            gaSupport: false,
            trackPageViewOnSearchUpdate: false,
        },
        defaultQueryParams: {
            isWWW: "*",
        },
        getSubNav: (numberOfComparedItems: number) => (
            <WebsiteTechnologiesSubNav numberOfComparedItems={numberOfComparedItems} />
        ),
        hidePageTitle: true,
        reloadOnSearch: true,
        isUSStatesSupported: false,
        skipDurationCheck: true,
        skipCountryCheck: true,
        homeState: "digitalsuite_websiteanalysis_home",
    },
    digitalsuite_website_trafficandengagement: {
        parent: "digitalsuite_website",
        url: `/traffic-engagement/:isWWW/:country/:duration?${trafficAndEngagementQueryParams}`,
        params: {
            isWWW: "*",
            country: "999",
            duration: "3m",
            [TRAFFIC_MONTH_TO_DATE_QUERY_PARAM]: "false",
            [ENGAGEMENT_MONTH_TO_DATE_QUERY_PARAM]: "false",
            ...filterConsistencyParams,
            comparedDuration: "",
        },
        defaultQueryParams: {
            duration: "3m",
            isWWW: "*",
            country: 999,
            comparedDuration: "",
            category: "no-category",
            webSource: devicesTypes.TOTAL,
        },
        component: AccessWithoutMandatoryParamsHOC(withAllContextHoc(WebsiteAnalysisTrafficContainerConnected), "key"),
        redirectTo: redirectPipe(
            fallback({
                salesIntelligence: "accountreview_website_trafficandengagement",
            }),
            onRedirectWebsiteAnalysisWithTotalWebSource(),
        ),
        stateNameForEductionBar: "companyresearch_website_trafficandengagement",
        periodOverPeriodEnabled: true,
        configId: "AudienceOverview",
        configIdDeps: ["MobileWeb", "InsightsHubOnboarding", "TrafficAndEngagement"],
        pageId: {
            section: "website",
            subSection: "audience",
            subSubSection: "overview",
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Website Analysis/Traffic",
            subSubSection: "trafficAndEngagement",
        },
        icon: "sw-icon-overview",
        pageTitle: "analysis.traffic.engagement.title",
        resolve: [
            resolvers.siteInfo,
            {
                token: "fetchAndUpdateBetaBranchStorePreference",
                resolveFn: () => fetchAndUpdateBetaBranchPreference(),
            },
        ],
        getGreenBadgeTitleComponent: () => {
            return (
                <BetaBranchGreenBadgeComponent text={"sub.nav.webanalysis.traffic.and.engagement.green.badge.title"} />
            );
        },
        data: {
            gaSupport: true,
            trackPageViewOnSearchUpdate: false,
        },
        hidePageTitle: true,
        reloadOnSearch: true,
        isUSStatesSupported: true,
        homeState: "digitalsuite_websiteanalysis_home",
        get showCreateCustomIndustryCta() {
            return !isNoTouchOrTrialOrAfterTrial();
        },
    },
    digitalsuite_website_marketingchannels: {
        parent: "digitalsuite_website",
        // The URL Is Overwritten later in file Pay attention
        url:
             
            "/overview/marketing-channels/:isWWW/:country/:duration/:comparedDuration?overviewTable_filters&category&webSource?channelAnalysisMtd?channelAnalysisGranularity?channelAnalysisChannel?channelAnalysisMetric?activeChannels?tableCategory?sourceType&key&channelsOverviewViewByType&channelsOverviewDataFormatType",
        defaultQueryParams: {
            category: "no-category",
            webSource: devicesTypes.TOTAL,
            isWWW: "*",
            duration: "3m",
            comparedDuration: "",
            country: 999,
        },
        params: {
            ...filterConsistencyParams,
            comparedDuration: "",
            channelsOverviewViewByType: { type: "string", value: "null", dynamic: true },
            channelsOverviewDataFormatType: { type: "string", value: "null", dynamic: true },
        },
        component: AccessWithoutMandatoryParamsHOC(() => <MmxContainer showCTAButton={true} />, "key"),
        qualificationSideBarComponent: QualificationSideBarContainer,
        redirectTo: redirectPipe(
            fallback({
                salesIntelligence: "accountreview_website_marketingchannels",
            }),
            onRedirectWebsiteAnalysis(),
        ),
        periodOverPeriodEnabled: true,
        customData: {
            resetFiltersOnWebSourceChange: {
                tableCategory: null,
                sourceType: null,
                unboundedVisits: null,
            },
            pageMenuTitle: "analysis.traffic.marketing.channels.title",
            navTitle: "analysis.sources.mmx.navTitle",
        },
        resolve: [resolvers.siteInfo],
        stateNameForEductionBar: "competitiveanalysis_website_overview_marketingchannels",
        pageId: {
            section: "website",
            subSection: "traffic",
            subSubSection: "overview",
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Website Analysis/Traffic",
            subSubSection: "marketingChannels",
        },
        icon: "sw-icon-overview",
        pageTitle: "analysis.traffic.marketing.channels.title",
        pageSubtitle: "analysis.traffic.marketing.channels.title.info",
        isUSStatesSupported: true,
        hidePageTitle: true,
        reloadOnSearch: false,
        get showCreateCustomIndustryCta() {
            return !isNoTouchOrTrialOrAfterTrial();
        },
        data: {
            trackPageViewOnSearchUpdate: false,
            pageViewTracking: marketingChannelsPageViewTracking,
        },
        childStates: {
            total: {
                configId: "MarketingMixTotal",
            },
        },
        configIdDeps: ["MobileMarketingMix", "MobileWeb", "IndustryAnalysis"],
        homeState: "digitalsuite_websiteanalysis_home",
    },
    digitalsuite_website_marketingchannels_beta: {
        parent: "digitalsuite_website",
        url: "/overview/marketing-channels-beta/:isWWW/:country/:duration/:comparedDuration?webSource?channelAnalysisMtd?channelAnalysisGranularity?channelAnalysisChannel?activeChannels?sourceType&key&channelsOverviewViewByType&channelsOverviewDataFormatType&tableCategory",
        defaultQueryParams: {
            webSource: devicesTypes.TOTAL,
            isWWW: "*",
            duration: "3m",
            comparedDuration: "",
            country: 999,
        },
        params: {
            isWWW: "*",
            country: "999",
            duration: "3m",
            ...filterConsistencyParams,
            comparedDuration: "",
            channelsOverviewViewByType: { type: "string", value: "null", dynamic: true },
            channelsOverviewDataFormatType: { type: "string", value: "null", dynamic: true },
        },
        component: AccessWithoutMandatoryParamsHOC(() => <MmxBetaContainer />, "key"),
        configId: "MarketingMixTotalBeta",
        qualificationSideBarComponent: QualificationSideBarContainer,
        onEnter: onEnterRemoveComparedDuration,
        redirectTo: redirectPipe(
            (transition) => ({
                state: "digitalsuite_website_marketingchannels",
                params: { ...transition.params() },
            }),
            onRedirectWebsiteAnalysis(),
        ),
        periodOverPeriodEnabled: false,
        customData: {
            resetFiltersOnWebSourceChange: {
                tableCategory: null,
                sourceType: null,
                unboundedVisits: null,
            },
            pageMenuTitle: "analysis.traffic.marketing.channels.title",
            navTitle: "analysis.sources.mmx.navTitle",
        },
        resolve: [resolvers.siteInfo],
        stateNameForEductionBar: "competitiveanalysis_website_overview_marketingchannels",
        pageId: {
            section: "website",
            subSection: "traffic",
            subSubSection: "overview",
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Website Analysis/Traffic",
            subSubSection: "marketingChannels",
        },
        icon: "sw-icon-overview",
        pageTitle: "analysis.traffic.marketing.channels.title",
        pageSubtitle: "analysis.traffic.marketing.channels.title.info",
        isUSStatesSupported: true,
        hidePageTitle: true,
        reloadOnSearch: false,
        get showCreateCustomIndustryCta() {
            return !isNoTouchOrTrialOrAfterTrial();
        },
        data: {
            trackPageViewOnSearchUpdate: false,
            pageViewTracking: marketingChannelsPageViewTracking,
        },
        childStates: {
            total: {
                configId: "MarketingMixTotal",
            },
        },
        configIdDeps: ["IndustryAnalysis"],
        homeState: "digitalsuite_websiteanalysis_home",
    },

    digitalsuite_website_audience: {
        parent: "digitalsuite_website",
        url: "/website-audience/:isWWW/:country/:duration?webSource?search?key&selectedTab&audienceCategory&customCategory&selectedSite&orderBy&audienceInterestsTable_filters&geography_filters",
        defaultQueryParams: { isWWW: "*", country: "999", duration: "3m", selectedTab: "Geography" },
        configId: "WebAudience",
        // @ts-ignore FIXME: strict migration - Type '... | null' is not assignable to type 'RedirectToResult' — transitionHookFn type excludes null but redirectPipe runtime explicitly handles null as "no redirect"
        redirectTo: (transition) => {
            if (isLocked(swSettings?.components?.WebAudience)) {
                return null;
            }

            const params = transition.params();
            const toState = transition.to();

            // Ensure all required path parameters are set - use defaults if missing
            const isWWW = params.isWWW ?? (toState as any).defaultQueryParams?.isWWW ?? "*";
            let country = params.country;
            if (!country || country === null || country === undefined) {
                country = (toState as any).defaultQueryParams?.country || "999";
            }
            const duration = params.duration ?? (toState as any).defaultQueryParams?.duration ?? "3m";

            const updatedParams = {
                ...params,
                isWWW,
                country,
                duration,
            };

            const requestedTab = (params.selectedTab || "").toLowerCase();

            const candidates = [
                {
                    component: swSettings?.components?.WebGeography,
                    state: "digitalsuite_website_geography",
                    selectedTab: ECategoryAudienceType.Geography,
                },
                {
                    component: swSettings?.components?.WebDemographics,
                    state: "digitalsuite_website_demographics",
                    selectedTab: ECategoryAudienceType.Demographics,
                },
                {
                    component: swSettings?.components?.WebAudienceInterests,
                    state: "digitalsuite_website_audienceInterests",
                    selectedTab: ECategoryAudienceType.AudienceInterests,
                },
                {
                    component: swSettings?.components?.WebAudienceOverlap,
                    state: "digitalsuite_website_audienceOverlap",
                    selectedTab: ECategoryAudienceType.AudienceOverlap,
                },
            ];
            const matchedByTab = candidates.find(
                ({ selectedTab, component }) => selectedTab.toLowerCase() === requestedTab && isAvailable(component),
            );

            if (matchedByTab) {
                return {
                    state: matchedByTab.state,
                    params: {
                        ...updatedParams,
                        selectedTab: matchedByTab.selectedTab,
                    },
                };
            }
            const fallback = candidates.find(({ component }) => isAvailable(component));

            if (fallback) {
                return {
                    state: fallback.state,
                    params: {
                        ...updatedParams,
                        selectedTab: fallback.selectedTab,
                    },
                };
            }

            // If no candidates are available, allow navigation to proceed to the audience state
            // This will show the wrapper component which handles the case when no tabs are available
            return {
                params: updatedParams,
            };
        },
        component: AccessWithoutMandatoryParamsHOC(AudienceWrapper, "key"),
    },

    digitalsuite_website_geography: {
        parent: "digitalsuite_website_audience",
        defaultQueryParams: {
            duration: "3m",
            country: 999,
            isWWW: "*",
            webSource: devicesTypes.TOTAL,
        },
        params: {
            ...filterConsistencyParams,
        },
        configId: "WebGeography",
        stateNameForEductionBar: "companyresearch_website_geography",
        skipCountryCheck: true,
        redirectTo: redirectPipe(
            fallback({
                salesIntelligence: "accountreview_website_audience_geography",
            }),
            onRedirectWebsiteAnalysis(),
        ),
        hidePageTitle: true,

        resolve: [resolvers.siteInfo],
        pageId: {
            section: "website",
            subSection: "audience",
            subSubSection: ECategoryAudienceType.Geography,
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Website Analysis/Audience",
            subSubSection: ECategoryAudienceType.Geography,
        },
        icon: "sw-icon-geography",

        pageTitle: "analysis.audience.title",

        isUSStatesSupported: false,
        data: { filtersConfig: { webSource: FiltersEnum.DISABLED, country: FiltersEnum.HIDDEN } },
    },

    digitalsuite_website_demographics: {
        parent: "digitalsuite_website_audience",
        defaultQueryParams: {
            duration: "3m",
            country: 999,
            isWWW: "*",
        },
        params: {
            ...filterConsistencyParams,
            webSource: devicesTypes.TOTAL,
        },
        configId: "WebDemographics",
        stateNameForEductionBar: "companyresearch_website_demographics_user_based",
        redirectTo: redirectPipe(
            fallback({
                salesIntelligence: "accountreview_website_audience_demographics",
            }),
            onRedirectWebsiteAnalysis(),
        ),
        hidePageTitle: true,
        resolve: [resolvers.siteInfo],
        pageId: {
            section: "website",
            subSection: "audience",
            subSubSection: ECategoryAudienceType.Demographics,
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Website Analysis/Audience",
            subSubSection: ECategoryAudienceType.Demographics,
        },
        overrideDatepickerPreset: ["1m", "3m", "6m", "12m", "25m"],
        icon: "sw-icon-demographics",
        pageTitle: "analysis.audience.title",
        isUSStatesSupported: false,
    },

    digitalsuite_website_audienceInterests: {
        parent: "digitalsuite_website_audience",
        defaultQueryParams: {
            isWWW: "*",
            duration: "3m",
            country: 999,
        },
        configId: "WebAudienceInterests",
        params: {
            ...filterConsistencyParams,
            webSource: devicesTypes.TOTAL,
        },
        stateNameForEductionBar: "companyresearch_website_audienceInterests",
        redirectTo: redirectPipe(
            fallback({
                salesIntelligence: "accountreview_website_audience_interests",
            }),
            onRedirectWebsiteAnalysis(),
        ),
        hidePageTitle: true,
        data: { filtersConfig: { webSource: FiltersEnum.DISABLED } },
        resolve: [resolvers.siteInfo],
        pageId: {
            section: "website",
            subSection: "audience",
            subSubSection: "interests",
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Website Analysis/Audience",
            subSubSection: ECategoryAudienceType.AudienceInterests,
        },
        icon: "sw-icon-audience",
        pageTitle: "analysis.audience.title",
        qualificationSideBarComponent: QualificationSideBarContainer,
        searchParams: ["state"],
        reloadOnSearch: true,
        isVirtualSupported: false,
        isUSStatesSupported: true,
        childStates: {
            desktop: {
                configId: "WebAudienceInterests",
            },
            mobileweb: {
                configId: "WebMobileAudienceInterests",
            },
            total: {
                configId: "WebMobileAudienceInterests",
            },
        },
        configIdDeps: ["WebAnalysis", "MobileWebSearch", "WebMobileAudienceInterests", "MobileWeb"],
    },

    digitalsuite_website_audienceOverlap: {
        parent: "digitalsuite_website_audience",
        defaultQueryParams: {
            isWWW: "*",
            duration: "3m",
            country: 999,
        },
        configId: "WebAudienceOverlap",
        params: {
            ...filterConsistencyParams,
            webSource: devicesTypes.TOTAL,
        },
        stateNameForEductionBar: "companyresearch_website_audienceOverlap",
        redirectTo: onRedirectWebsiteAnalysis(),
        hidePageTitle: true,
        resolve: [resolvers.siteInfo],
        pageId: {
            section: "website",
            subSection: "audience",
            subSubSection: ECategoryAudienceType.AudienceOverlap,
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Website Analysis/Audience",
            subSubSection: ECategoryAudienceType.AudienceOverlap,
        },
        icon: "sw-icon-audience",

        pageTitle: "analysis.audience.title",
        isNew: true,
        reloadOnSearch: true,
        isVirtualSupported: false,
        isUSStatesSupported: false,
        overrideDatepickerPreset: ["1m", "3m", "6m", "12m", "25m", "37m"],
        minDurationRange: 1,
    },
    digitalsuite_website_content: {
        parent: "digitalsuite_website",
        url: "/overview/website-content/:isWWW/:country/:duration?webSource?selectedSite&key&selectedTab&graphCategory&chartCategories",
        defaultQueryParams: { isWWW: "*", country: "999", duration: "3m", selectedTab: "Folders" },
        configId: "WebsiteContent",
        // @ts-ignore FIXME: strict migration - Type '... | null' is not assignable to type 'RedirectToResult' — transitionHookFn type excludes null but redirectPipe runtime explicitly handles null as "no redirect"
        redirectTo: (transition) => {
            if (isLocked(swSettings.components.WsWebWebsiteContent)) {
                
                return GrowthbookService.growthbookInstance.isOn(TestsNames.TOUCH_HOOKS_DUMMY_PAGE) && isNoTouch(swSettings)
                    ? {
                          state: "digitalsuite_website_content_locked",
                          params: transition.params(),
                      }
                    : null;
            }

            const params = transition.params();
            const requestedTab = (params.selectedTab || "").toLowerCase();

            const candidates = [
                {
                    component: swSettings.components.WsWebContentFolders,
                    state: "digitalsuite_website_folders",
                    selectedTab: "Folders",
                },
                {
                    component: swSettings.components.PopularPagesV2,
                    state: "digitalsuite_website_popular_v2",
                    selectedTab: "PopularPages",
                },
                {
                    component: swSettings.components.WsWebContentSubdomains,
                    state: "digitalsuite_website_subdomains",
                    selectedTab: "Subdomains",
                },
                {
                    component: swSettings.components.WebsiteLOBs,
                    state: "digitalsuite_website_lob",
                    selectedTab: "LOB",
                },
            ];
            const matchedByTab = candidates.find(
                ({ selectedTab, component }) => selectedTab.toLowerCase() === requestedTab && isAvailable(component),
            );

            if (matchedByTab) {
                return {
                    state: matchedByTab.state,
                    params: {
                        ...params,
                        selectedTab: matchedByTab.selectedTab,
                    },
                };
            }
            const fallback = candidates.find(({ component }) => isAvailable(component));

            return fallback
                ? {
                      state: fallback.state,
                      params: {
                          ...params,
                          selectedTab: fallback.selectedTab,
                      },
                  }
                : null;
        },
        component: AccessWithoutMandatoryParamsHOC(WebsiteContent, "key"),
    },
    digitalsuite_website_content_locked: {
        parent: "digitalsuite_website",
        url: "/overview/website-content-locked/:isWWW/:country/:duration?webSource?selectedSite&key&selectedTab",
        defaultQueryParams: { isWWW: "*", country: "999", duration: "3m" },
        // @ts-ignore FIXME: strict migration - Type '... | null' is not assignable to type 'RedirectToResult' — transitionHookFn type excludes null but redirectPipe runtime explicitly handles null as "no redirect"
        redirectTo: (transition) =>
            !isLocked(swSettings.components.WsWebWebsiteContent) ||
            !GrowthbookService.growthbookInstance.isOn(TestsNames.TOUCH_HOOKS_DUMMY_PAGE) || !isNoTouch(swSettings)
                ? {
                      state: "digitalsuite_website_content",
                      params: transition.params(),
                  }
                : null,
        component: WebsiteContentLockedPage,
        resolve: [resolvers.siteInfo],
        pageTitle: "analysis.overview.website.content.title",
        pageSubtitle: "analysis.overview.website.content.subtitle",
        pageLayoutClassName: "sw-layout-page website-content-locked-page",
        pageId: { section: "digitalsuite", subSection: "websiteContentLocked" },
    },
    digitalsuite_website_subdomains: {
        parent: "digitalsuite_website_content",
        defaultQueryParams: {
            isWWW: "*",
            duration: "3m",
            country: 999,
        },
        params: {
            ...filterConsistencyParams,
            key: {
                dynamic: false,
            },
        },
        stateNameForEductionBar: "companyresearch_website_subdomains",
        redirectTo: onRedirectWebsiteAnalysis(),
        resolve: [resolvers.siteInfo],
        pageId: {
            section: "website",
            subSection: "overview",
            subSubSection: "websiteContent/subdomains",
        },
        configId: "SubDomains",
        trackingId: {
            section: "Competitive Research",
            subSection: "Website Analysis/Overview",
            subSubSection: "websiteContent",
        },
        icon: "sw-icon-subdomains",
        pageTitle: "analysis.overview.website.content.title",
        pageSubtitle: "analysis.overview.website.content.subtitle",
        hidePageTitle: true,
        childStates: {
            desktop: {
                configId: "SubDomains",
            },
            mobileweb: {
                configId: "SubDomainsMobile",
            },
        },
        configIdDeps: ["MobileWeb"],
        searchParams: ["webSource"],
        reloadOnSearch: true,
        isVirtualSupported: false,
        isUSStatesSupported: true,
        data: {
            trackPageViewOnSearchUpdate: false,
        },
        homeState: "digitalsuite_website_content",
    },
    digitalsuite_websites_paidoutgoing_advertisers: {
        parent: "digitalsuite_website",
        url: "/traffic-paid-outgoing-advertisers/:isWWW/:country/:duration?&webSource&industry&network&search&orderBy&key",
        defaultQueryParams: {
            isWWW: "*",
            duration: "3m",
            webSource: devicesTypes.DESKTOP,
        },
        params: {
            isWWW: "*",
            duration: "3m",
            country: "999",
            key: {
                dynamic: false,
            },
            ...filterConsistencyParams,
        },
        component: AccessWithoutMandatoryParamsHOC(AdvertisersContainer, "key"),
        qualificationSideBarComponent: QualificationSideBarContainer,
        redirectTo: redirectPipe(onRedirectWebsiteAnalysis()),
        configId: "PaidOutgoing",
        pageId: {
            section: "website",
            subSection: "destination",
            subSubSection: "paidoutgoing",
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Website Analysis/Monetization",
            subSubSection: "advertisers",
        },
        icon: "sw-icon-paid-outgoing",
        hidePageTitle: true,
        pageTitle: "analysis.advertisers.title",
        pageSubtitle: "analysis.advertisers.title.info",
        isUSStatesSupported: true,
        reloadOnSearch: true,
        data: {
            trackPageViewOnSearchUpdate: false,
            filtersConfig: {
                webSource: FiltersEnum.DISABLED,
            },
        },
        resolve: [resolvers.siteInfo],
        homeState: "digitalsuite_websiteanalysis_home",
    },
    digitalsuite_websites_paidoutgoing_monetization_networks: {
        parent: "digitalsuite_website",
        url: "/traffic-paid-outgoing/:isWWW/:country/:duration?AdNetwork_filters&AdNetwork_orderby&webSource&key",
        defaultQueryParams: {
            isWWW: "*",
            duration: "3m",
            webSource: devicesTypes.DESKTOP,
        },
        params: {
            isWWW: "*",
            duration: "3m",
            country: "999",
            key: {
                dynamic: false,
            },
            ...filterConsistencyParams,
        },
        component: AccessWithoutMandatoryParamsHOC(MonetizationNetworksContainer, "key"),
        redirectTo: redirectPipe(onRedirectWebsiteAnalysis()),
        resolve: [resolvers.siteInfo],
        configId: "PaidOutgoingMonetization",
        pageId: {
            section: "website",
            subSection: "destination",
            subSubSection: "paidoutgoing",
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Website Analysis/Monetization",
            subSubSection: "adNetworks",
        },
        icon: "sw-icon-paid-outgoing",
        pageTitle: "analysis.monetization.title",
        hidePageTitle: true,
        pageSubtitle: "analysis.monetization.title.tooltip",
        isUSStatesSupported: true,
        reloadOnSearch: true,
        data: {
            trackPageViewOnSearchUpdate: false,
            filtersConfig: {
                webSource: FiltersEnum.DISABLED,
            },
        },
        homeState: "digitalsuite_websiteanalysis_home",
    },
    digitalsuite_website_popular_v2: {
        parent: "digitalsuite_website_content",
        defaultQueryParams: {
            duration: "3m",
            country: 999,
            webSource: devicesTypes.TOTAL,
        },
        params: {
            webSource: devicesTypes.TOTAL,
            isWWW: "*",
            comparedDuration: "",
            ...filterConsistencyParams,
        },
        redirectTo: redirectPipe(onRedirectWebsiteAnalysis()),
        stateNameForEductionBar: "companyresearch_website_popular",
        hidePageTitle: true,
        configId: "PopularPagesV2",
        configIdDeps: ["MobileWeb"],
        resolve: [resolvers.siteInfo],
        pageId: {
            section: "website",
            subSection: "overview",
            subSubSection: "websiteContent/popular",
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Website Analysis/Overview",
            subSubSection: "websiteContent",
        },
        icon: "sw-icon-page-views",
        customData: {
            notPermittedConfig: {
                image: AssetsService.assetUrl("images/popularPagesHook.png"),
                description: "website.popular.pages.desc",
            },
        },
        pageTitle: "analysis.overview.website.content.title",
        pageSubtitle: "analysis.overview.website.content.subtitle",
        searchParams: ["state"],
        isVirtualSupported: false,
        isUSStatesSupported: true,
        reloadOnSearch: true,
        data: {
            filtersConfig: {
                webSource: FiltersEnum.ENABLED,
            },
        },
        homeState: "digitalsuite_website_content",
    },
    digitalsuite_website_folders: {
        parent: "digitalsuite_website_content",
        defaultQueryParams: {
            duration: "3m",
            country: 999,
            isWWW: "*",
        },
        params: {
            ...filterConsistencyParams,
        },
        stateNameForEductionBar: "companyresearch_website_folders",
        redirectTo: onRedirectWebsiteAnalysis(),
        hidePageTitle: true,
        configId: "FoldersAnalysis",
        configIdDeps: ["MobileWeb"],
        resolve: [resolvers.siteInfo],
        pageId: {
            section: "website",
            subSection: "overview",
            subSubSection: "websiteContent/folders",
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Website Analysis/Overview",
            subSubSection: "websiteContent",
        },
        icon: "sw-icon-tabs-leading-folders",
        customData: {
            notPermittedConfig: {
                image: AssetsService.assetUrl("images/popularPagesHook.png"),
                description: "website.popular.pages.desc",
            },
        },
        pageTitle: "analysis.overview.website.content.title",
        pageSubtitle: "analysis.overview.website.content.subtitle",
        searchParams: ["state"],
        isVirtualSupported: false,
        isUSStatesSupported: true,
        reloadOnSearch: true,
        homeState: "digitalsuite_website_content",
    },
    digitalsuite_website_lob: {
        parent: "digitalsuite_website_content",
        defaultQueryParams: {
            duration: "3m",
            country: 999,
            isWWW: "*",
        },
        params: {
            ...filterConsistencyParams,
        },
        stateNameForEductionBar: "companyresearch_website_line_of_business",
        hidePageTitle: true,
        configId: "WebsiteLOBs",
        resolve: [resolvers.siteInfo],
        pageId: {
            section: "website",
            subSection: "overview",
            subSubSection: "websiteContent/lob",
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Website Analysis/Overview",
            subSubSection: "websiteContent",
        },
        pageTitle: "analysis.overview.website.content.title",
        pageSubtitle: "analysis.overview.website.content.subtitle",
        searchParams: ["state"],
        isVirtualSupported: false,
        isUSStatesSupported: true,
        reloadOnSearch: true,
        homeState: "digitalsuite_website_content",
    },
    digitalsuite_website_sneakpeekQuery: {
        parent: "digitalsuite_website",
        url: "/sneakpeek/query/:isWWW/:country/:duration?key&editedId",
        params: {
            isWWW: "*",
            country: "999",
            duration: "3m",
        },
        component: AccessWithoutMandatoryParamsHOC((props) => <SneakpeekQuery {...props} />, "key", "website"),
        configId: "WebSiteSneakpeek",
        pageId: {
            section: "website",
            subSection: "sneakpeek",
            subSubSection: "query",
        },
        trackingId: {
            section: "websiteAnalysis",
            subSection: "sneakpeek",
            subSubSection: "query",
        },
        icon: "sw-icon-overview",
        pageTitle: "Create Data Prototype",
        resolve: [resolvers.siteInfo],
        hidePageTitle: true,
        reloadOnSearch: true,
        isUSStatesSupported: true,
        defaultQueryParams: {
            isWWW: "*",
            country: 999,
            duration: "3m",
        },
    },
    digitalsuite_website_sneakpeekResults: {
        parent: "digitalsuite_website",
        url: "/sneakpeek/results/:isWWW/:country/:duration?key&queryId",
        params: {
            isWWW: "*",
            country: "999",
            duration: "3m",
        },
        component: AccessWithoutMandatoryParamsHOC(SneakpeekResultsPage, "key", "website"),
        configId: "WebSiteSneakpeek",
        pageId: {
            section: "website",
            subSection: "sneakpeek",
            subSubSection: "results",
        },
        trackingId: {
            section: "websiteAnalysis",
            subSection: "sneakpeek",
            subSubSection: "results",
        },
        icon: "sw-icon-overview",
        pageTitle: "Data Prototype Results",
        resolve: [resolvers.siteInfo],
        hidePageTitle: true,
        reloadOnSearch: true,
        isUSStatesSupported: true,
        defaultQueryParams: {
            isWWW: "*",
            country: 999,
            duration: "3m",
        },
    },
    digitalsuite_segments: {
        parent: "digitalsuite_marketresearch",
        name: "segments",
        secondaryBarType: "DigitalSuiteCompetition",
        secondaryBarType3: SecondarySideBarType3.SegmentAnalysis,
        abstract: true,
        url: "/segments",
        configId: "CustomSegments",
        component: SegmentsRootContainer,
        entityType: "segment",
    },
    "digitalsuite_segments-homepage": {
        parent: "digitalsuite_segments",
        url: "/home?tab",
        params: {
            tab: {
                type: "string",
                value: ETab.MY_SEGMENTS.toString(),
                squash: false,
                dynamic: true,
            },
        },
        name: "segments.homepage",
        component: SegmentsHomepageContainer,
        secondaryBarType: "DigitalSuiteCompetition",
        secondaryBarType3: SecondarySideBarType3.None,
        isSecondaryBarOpen: true,
        configId: "CustomSegments",
        stateNameForEductionBar: "digitalsuite_segments_homepage",
        configIdDeps: ["MobileWeb", "MobileWebCustomSegmentsAnalysis"],
        pageId: {
            section: "segments",
            subSection: "homepage",
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Segment Analysis/Home",
            subSubSection: "",
        },
        pageTitle: "segments.homepage.title",
        reloadOnSearch: true,
    },
    [SEGMENTS_ANALYSIS_ABSTRACT_PARENT_ID]: {
        parent: "digitalsuite_segments",
        name: "segments.analysis",
        url: "/analysis",
        abstract: true,
        component: SegmentsAnalysisRootContainer,
        resolve: [resolvers.customSegments],
        isModuleSupportSegments: true,
    },
    "digitalsuite_segments-analysis-traffic": {
        parent: SEGMENTS_ANALYSIS_ABSTRACT_PARENT_ID,
        name: "segments.analysis.traffic",
        periodOverPeriodEnabled: true,
        stateNameForEductionBar: "digitalsuite_segments_analysis_traffic",
        url: "/:mode/:id/:country/:duration?comparedDuration&webSource",
        component: withAllContextHoc(SegmentsAnalysisTrafficContainer),
        redirectTo: onRedirectSegmentAnalysis(),
        params: {
            webSource: devicesTypes.TOTAL,
            ...filterConsistencyParams,
        },
        configId: "CustomSegments",
        configIdDeps: ["MobileWeb", "MobileWebCustomSegmentsAnalysis", "TotalWebCustomSegmentsAnalysis"],
        pageId: {
            section: "segments",
            subSection: "analysis",
            subSubSection: "traffic",
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Segment Analysis/Audience",
            subSubSection: ((params: any) => (params.mode === "group" ? "comparison" : "traffic")) as any,
        },
        pageTitle: "segments.analysis.traffic.title",
        ...FILTER_CONSISTENCY_CUSTOM_KEYS,
    },
    "digitalsuite_segments-analysis-marketingChannels": {
        parent: SEGMENTS_ANALYSIS_ABSTRACT_PARENT_ID,
        name: "segments.analysis.marketingChannels",
        periodOverPeriodEnabled: false,
        url: "/traffic-channels/:mode/:id/:country/:duration?webSource",
        component: withAllContextHoc(SegmentsAnalysisMarketingChannelsContainer),
        redirectTo: onRedirectSegmentAnalysis(),
        stateNameForEductionBar: "digitalsuite_segments_analysis_marketingChannels",
        childStates: {
            desktop: {
                configId: "CustomSegments",
            },
            total: {
                configId: "TotalMarketingChannelsCustomSegmentsAnalysis",
            },
        },
        configIdDeps: ["MobileWeb", "MobileWebCustomSegmentsAnalysis"],
        pageId: {
            section: "segments",
            subSection: "analysis",
            subSubSection: "marketing Channels",
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Segment Analysis/Acquisition",
            subSubSection: "marketing Channels",
        },
        pageTitle: "segments.analysis.marketingChannels.title",
        defaultQueryParams: {
            duration: "3m",
        },
        params: {
            ...filterConsistencyParams,
        },
        ...FILTER_CONSISTENCY_CUSTOM_KEYS,
    },
    "digitalsuite_segments-analysis-geography": {
        parent: SEGMENTS_ANALYSIS_ABSTRACT_PARENT_ID,
        name: "segments.analysis.geography",
        periodOverPeriodEnabled: false,
        url: "/geography/:mode/:id/:country/:duration?webSource",
        component: withAllContextHoc(SegmentsGeographyContainer),
        redirectTo: onRedirectSegmentAnalysis(),
        configId: "CustomSegments",
        stateNameForEductionBar: "digitalsuite_segments_analysis_geography",
        configIdDeps: ["MobileWeb", "MobileWebCustomSegmentsAnalysis"],
        pageId: {
            section: "segments",
            subSection: "analysis",
            subSubSection: "geography",
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Segment Analysis/Audience",
            subSubSection: "geography",
        },
        pageTitle: "segments.analysis.geography.title",
        data: {
            filtersConfig: {
                country: FiltersEnum.HIDDEN,
            },
        },
        params: {
            ...filterConsistencyParams,
        },
        ...FILTER_CONSISTENCY_CUSTOM_KEYS,
    },
    "digitalsuite_segments-wizard": {
        parent: "digitalsuite_segments",
        url: "/wizard?sid?country?createNew",
        component: withAllContextHoc(SegmentsWizardWrapper),
        configId: "CustomSegments",
        configIdDeps: ["MobileWeb", "MobileWebCustomSegmentsAnalysis"],
        pageId: {
            section: "segments",
            subSection: "wizard",
        },
        trackingId: {
            section: "segments",
            subSection: "wizard",
        },
        pageTitle: "segments.wizard.title",
        secondaryBarType: "None",
        secondaryBarType3: SecondarySideBarType3.SegmentAnalysis,
        hideSecondaryBar3: true,
    },
    "digitalsuite_segments-buyer_journey": {
        parent: SEGMENTS_ANALYSIS_ABSTRACT_PARENT_ID,
        url: "/buyerjourney/:mode/:id/:country/:duration?webSource",
        component: SegmentUserFlowContainer,
        configId: "SegmentAnalysisUserFlow",
        stateNameForEductionBar: "digitalsuite_segments_buyer_journey",
        pageId: {
            section: "segments",
            subSection: "analysis",
            subSubSection: "user journey",
        },
        trackingId: {
            section: "Competitive Research",
            subSection: "Segment Analysis/user journey",
            subSubSection: "user journey",
        },
        params: {
            duration: "3m",
            ...filterConsistencyParams,
        },
        defaultQueryParams: {
            duration: "3m",
        },
        pageTitle: "segments.buyerjourney.title",
        pinkBadgeTitle: "sidenav.beta",
        redirectTo: redirectPipe((transition) => {
            return journeyTransitionRedirect(transition);
        }, onRedirectSegmentAnalysis()),
        ...FILTER_CONSISTENCY_CUSTOM_KEYS,
    },
    ...competitionAppAnalysisConfig,
    ...competitionMarketingAnalysisConfig,
};

config["digitalsuite_website_marketingchannels_duplicate"] = {
    ...config["digitalsuite_website_marketingchannels"],
    redirectTo: "digitalsuite_website_marketingchannels",
};
config["digitalsuite_website_marketingchannels"].url =
     
    "/traffic-overview/:isWWW/:country/:duration/:comparedDuration?search?overviewTable_filters&category&webSource?channelAnalysisMtd?channelAnalysisGranularity?channelAnalysisChannel?tableCategory?sourceType?channelAnalysisMetric&key?unboundedVisits";

config["digitalsuite_website_trafficandengagement_duplicate"] = {
    ...config["digitalsuite_website_trafficandengagement"],
    redirectTo: "digitalsuite_website_trafficandengagement",
};
config["digitalsuite_website_trafficandengagement"].url =
    `/traffic-engagement/:isWWW/:country/:duration/:comparedDuration?webSource?selectedWidgetTab&key&category&${TRAFFIC_ENGAGED_USERS_QUERY_PARAM}&${ENGAGEMENT_ENGAGED_USERS_QUERY_PARAM}&${SELECTED_TRAFFIC_METRIC_QUERY_PARAM}&${SELECTED_ENGAGMENT_METRIC_QUERY_PARAM}`;

export const competitionConfig = config;
